export const UPCOMING = "upcoming";
export const COMPLETED = "completed";
export const YOUR_FEES = "your_fees";
export const PAYOUT_INFORMATION = "payout_information";
export const SETTINGS = "settings";
export const DOMESTIC = "domestic";
export const INTERATIONAL = "international";
